import React from 'react'
import { OnboardingCartDrawerDeliverySummary } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartBasketSummary/OnboardingCartDrawerDeliverySummary'
import { OnboardingCartDrawerTotalPrice } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartBasketSummary/OnboardingCartDrawerTotalPrice'
import { flex } from 'styled-system/patterns'

export const OnboardingCartBasketSummary = () => {
  return (
    <div
      className={flex({
        justifyContent: 'space-between',
        gap: 2,
      })}
    >
      <OnboardingCartDrawerDeliverySummary />
      <OnboardingCartDrawerTotalPrice />
    </div>
  )
}
